import { RouteInfo } from "./types";
import { authGuard, permissionGuard } from "./guards/index";
import { UIPAGE } from "@/constants/ui-page.constants";
import { ColorStatusType } from "@/constants/colors.constants";

const ViewProducts = () => import(/* webpackChunkName: "chunk-products" */ "@/views/product/Products.vue");

export const ProductsRoute: RouteInfo = {
	id: UIPAGE.PRODUCTS,
	path: "/products",
	component: ViewProducts,
	guards: [authGuard, permissionGuard],
	title: "products.display",
	icon: "mdi-package-variant-closed",
	iconColor: ColorStatusType.ORANGE_LIGHT
};
